export const receiptDetails: {
  title: string;
  description: string;
  key: string;
  hasBorder?: boolean;
  hasIcon?: boolean;
}[] = [
  {
    title: "DATE",
    key: "createdAt",
    description: "",
  },
  {
    title: "TRANSACTION TYPE",
    key: "transferType",
    description: "",
  },
  {
    title: "PAYMENT CHANNEL",
    key: "paymentChannel",
    description: "",
    hasBorder: true,
  },
  {
    title: "AMOUNT SENT",
    key: "amount",
    description: "",
  },
  {
    title: "TRANSACTION FEE",
    key: "transferFee",
    description: "",
  },
  {
    title: "RECIPIENT'S TAG",
    key: "recipientTag",
    description: "",
  },
  {
    title: "RECIPIENT'S FULL NAME",
    key: "recipientFullName",
    description: "",
  },
  {
    title: "PHONE NUMBER",
    key: "recipientPhoneNumber",
    description: "",
  },
  {
    title: "BANK NAME",
    key: "recipientBankName",
    description: "",
  },
  {
    title: "RECIPIENT ACCOUNT NUMBER",
    key: "recipientAccountNumber",
    description: "",
  },
  {
    title: "PURPOSE OF TRANSACTION",
    key: "purpose",
    description: "",
  },
  {
    title: "TRANSACTION ID",
    key: "id",
    description: "",
    hasIcon: true,
  },
  {
    title: "STATUS",
    key: "transferStatus",
    description: "",
  },
];

export const returnReceiptTitle = ({
  isFipayTag,
  isPayAnyone,
  isBankTransfer,
  isWireTransfer,
}: {
  isFipayTag: boolean;
  isPayAnyone: boolean;
  isBankTransfer: boolean;
  isWireTransfer: boolean;
}) => {
  return receiptDetails.filter((detail) =>
    isFipayTag
      ? detail.title !== "PHONE NUMBER" &&
        detail.title !== "BANK NAME" &&
        detail.title !== "RECIPIENT'S FULL NAME" &&
        detail.title !== "RECIPIENT ACCOUNT NUMBER"
      : isPayAnyone
        ? detail.title !== "BANK NAME" &&
          detail.title !== "RECIPIENT'S TAG" &&
          detail.title !== "RECIPIENT ACCOUNT NUMBER"
        : isBankTransfer
          ? detail.title !== "PHONE NUMBER" &&
            detail.title !== "RECIPIENT'S TAG"
          : isWireTransfer
            ? detail.title !== "PHONE NUMBER" &&
              detail.title !== "RECIPIENT'S TAG"
            : detail
  );
};
export const buttonTexts: string[] = ["Download Receipt", "Repeat Transaction"];
